/* global Liferay */

import { config, RenewHealthStatus, BloodDonationConstants, isLiferay, LiferayPages } from "./constants";
import Cookies from "js-cookie";
import { getTokenJson } from "../services/liferay/common";
import axios from "axios";


//import moment from "moment";

export function showError(title, message) {
  Liferay.Util.openToast({ message, title, type: "danger" });
}

export function showSuccess(title, message) {
  Liferay.Util.openToast({ message, title, type: "success" });
}

export function getCookie(name) {
  let cookies = document.cookie.split(";");
  let cookiesMap = cookies.map((item) => {
    const eqIdx = item.indexOf("=");
    return {
      key: item.substring(0, eqIdx === -1 ? item.length : eqIdx).trim(),
      value: eqIdx === -1 ? "" : item.substring(eqIdx + 1).trim()
    };
  });

  return cookiesMap.find((item) => item.key === name);
}

export function getCurrentLocale() {
  if (typeof Liferay != "undefined" && Liferay) {
    return Liferay.ThemeDisplay.getLanguageId();
  } else {
    let epicJson = getTokenJson();
    if (epicJson) {
      let language = epicJson.lang;
      if (language) {
        let userlang = language.split("-")[0];
        return userlang;
      }
    } else if (typeof window !== "undefined") {

      const htmlLang = window.parent.document.documentElement.lang;
      if (htmlLang) {
        return htmlLang;
      }
    }
    return "en";
  }
}

export const getRenewHealthStatusColor = (status) => {
  switch (status) {
    case "Active":
      return RenewHealthStatus.active.iconColor;
    case "Expired":
      return RenewHealthStatus.expired.iconColor;
    case "Expiring Soon":
      return RenewHealthStatus.expiringSoon.iconColor;
    default:
      return null;
  }
};


export function updateThePlanNewName(code, planName, translationMap) {
  let plancode = code.toString().trim();
  if (plancode) {
    if (plancode === "248") {
      return translationMap?.uaeNationalCoverage || "UAE National Coverage";
    } else if (plancode === "274") {
      return translationMap?.epdCoverage || "Emirates Passport Dubai Coverage";
    } else if (plancode === "259") {
      return translationMap?.uaeNationalMotherCoverage || "UAE National Mother Coverage";

    } else if (plancode === "251") {
      return translationMap?.gccDubaiResidentCoverage || "GCC Dubai Resident Coverage";
    }

  }
  return planName;
}


export function setItemWithExpiry(key, value, ttl) {
  const now = new Date();

  // `ttl` is time to live in milliseconds
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  };

  localStorage.setItem(key, JSON.stringify(item));
}

export function getItemWithExpiry(key) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();


  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

export function isMychart() {
  return !isLiferay;
}

export function configureFirstIframe(timeout, height, isRest) {
  if (isMychart() && window.location.hostname !== 'localhost') {
    setTimeout(() => {
      // Access the parent window's iframes
      const iframes = window.parent.document.getElementsByTagName("iframe");

      if (iframes.length > 0) {
        const firstIframe = iframes[0];

        // Set scrolling to "no" for the first iframe
        firstIframe.setAttribute("scrolling", "no");

        // Adjust the iframe's height based on its content
        try {
          const contentDocument = firstIframe.contentWindow.document;
          let currentHeight = parseInt(contentDocument.documentElement.scrollHeight, 10);
          let additionalHeight = 0;
          if (height) {
            additionalHeight = parseInt(height, 10);
          }
          if (isRest) {
            currentHeight = 0;
          }
          const newHeight = currentHeight + additionalHeight;
          firstIframe.style.height = `${newHeight}px`;
        } catch (error) {
          console.error("configureFirstIframe: Error accessing iframe content.", error);
        }
      } else {
        console.warn("configureFirstIframe: No iframes found in the parent document.");
      }

    }, timeout);
  }

}

export const getLayoutDirection = (locale) => {
  locale = locale || getCurrentLocale();
  return locale === "ar" || locale === "ar_SA" ? "direction-rtl" : "direction-ltr";
};

export const isArabic = () => {
  let locale = getCurrentLocale();
  return locale === "ar" || locale === "ar_SA";

};


export const isValidUAENumber = (number) => {

  const uaePhoneRegex = /^(?:\+971|971|0)?(50|55|52|54|56|58|59)\d{7}$/;
  return uaePhoneRegex.test(number);
};

export const checkIfMyChart = () => {
  const iFrameDetection = window !== window.parent;
  return iFrameDetection && Cookies.get(config.LFR_MYCHART_ATD);
};

export const isLoggedIn = () => {
  return window.Liferay.ThemeDisplay.isSignedIn();
};

export const checkIfUserIsLoggedIn = () => {
  if (typeof window !== 'undefined' && window.Liferay) {
    if (window.Liferay.ThemeDisplay.isSignedIn()) {
      return BloodDonationConstants?.LOGGED_IN;
    } else {
      return BloodDonationConstants?.NOT_lOGGED_IN;
    }
  } else {
    return BloodDonationConstants?.NOT_LIFERAY;
  }
};

export const isLiferayEnv = () => {
  if (typeof window !== 'undefined' && window.Liferay) {
    return true;
  } else {
    return false;
  }
};

export const calculateAgeInMonths = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const ageInMonths =
  (today.getFullYear() - birthDate.getFullYear()) * 12 +
  today.getMonth() -
  birthDate.getMonth();
  return ageInMonths > 0 ? ageInMonths : 0;
};

export function setLocalStorage(key, value) {
  const item = {
    value: value
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getLocalStorage(key) {
  let itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  return item.value;
}

// sentence capitcal - TEST USER - o/p - Test User
export function capitalizeWords(sentence) {
  return sentence
  .split(' ')
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(' ');
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function formatEmid(emid) {
  if (emid) {
    let value = emid.toString();
    return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(
      7,
      14
    )}-${value.slice(14)}`;
  }
  return emid;
}

export function isWebsiteCheck() {
  let tokenJson = getTokenJson();
  if (tokenJson) {
    return true;
  }
  return false;
}


export function isMobileApp() {
  let tokenJson = getTokenJson();
  if (tokenJson) {
    if (tokenJson?.source && "WEB" !== tokenJson.source.toString().replace(/"/g, "")) {
      return true;
    }
  }
  return false;

}

export function isAndroid() {
  return /android/i.test(navigator.userAgent);
}


export function openPdfToUrl(base64) {

  // Decode the Base64 string into binary data
  const binaryString = atob(base64);


  // Convert binary data to a Uint8Array
  const byteNumbers = Array.from(binaryString).map((char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob from the Uint8Array
  const blob = new Blob([byteArray], { type: "application/pdf" });


  // Generate a temporary URL for the Blob
  const tempUrl = URL.createObjectURL(blob);


  setTimeout(() => {
    URL.revokeObjectURL(tempUrl);
  }, 200000);

  return tempUrl;
}

export function reloadOnBrowserBack() {
  if (sessionStorage.getItem('redirectedFromPayment') === 'true') {
    sessionStorage.removeItem('redirectedFromPayment');
    window.parent.location.reload();
  }
}

export const calculateAdjustedAgeInMonths = (dob, prematurityWeeks) => {

  const birthDate = new Date(dob);
  const today = new Date();
  const ageInMonths =
  (today.getFullYear() - birthDate.getFullYear()) * 12 + (
  today.getMonth() - birthDate.getMonth()) + (
  today.getDate() >= birthDate.getDate() ? 0 : -1);

  const chronologicalAgeMonths = Math.max(ageInMonths, 0);

  const prematurityWeeksInt = parseInt(prematurityWeeks, 10) || 0;
  const isUnderTwoYearsOld = chronologicalAgeMonths < 24;
  if (isUnderTwoYearsOld && prematurityWeeksInt > 3) {
    let effectiveBirthDate = new Date(birthDate);
    const prematurityDays = (parseInt(prematurityWeeks, 10) || 0) === 3 ? 0 : (parseInt(prematurityWeeks, 10) || 0) * 7;
    effectiveBirthDate.setDate(effectiveBirthDate.getDate() + prematurityDays);
    let monthAfterPreMaturity = (today.getFullYear() - effectiveBirthDate.getFullYear()) * 12 + (
    today.getMonth() - effectiveBirthDate.getMonth()) + (
    today.getDate() >= effectiveBirthDate.getDate() ? 0 : -1);
    return monthAfterPreMaturity;
  }

  return chronologicalAgeMonths;


};

export const parseDate = (dob) => {
  if (!dob) return null;

  const formattedDob = new Date(dob);

  return formattedDob;
};

export const removeLeadingZero = (phoneNumber) => {
  if (!phoneNumber) {
    return "";
  }

  const phoneParts = phoneNumber.split(" ");

  if (phoneParts[0].startsWith("0")) {
    phoneParts[0] = phoneParts[0].slice(1);
  }

  return phoneParts.join(" ");
};

export const getLastNineCharacters = (input) => {
  if (typeof input !== 'string') {
    return '';
  }

  input = input.replace(/\s/g, '');

  if (input.length < 10) {
    return '';
  }

  return input.slice(-9);
};

export function formatMonthsRange(input) {
  const regex = /(\d{2}) - (\d{2})/;
  const match = input.match(regex);

  if (match) {

    return `${match[1]} - ${match[2]}`;
  }

  return input;
}

export function isMobileBrowser() {
  if (window.innerWidth < 990) return true;
  return false;
}

export async function getPaymentStatusStatus(service) {
  let paymentStatus = "";
  const requestConfig = {
    url: `${config.paymentServices}paymentStatus?service=${service}`,
    method: `GET`
  };

  let res = await axios.request(requestConfig);
  if (res.status === 200) {
    paymentStatus = res.data?.paymentStatus?.toLowerCase();
  }
  return paymentStatus;
}

export function convert(str) {
  if (!str) return "";
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
}

export function otherServicesDashboardURL() {
  return `${window.Liferay.ThemeDisplay.getPortalURL()}${isArabic() ? "/ar" : ""}${LiferayPages.otherServicesDashboardURL}`;
}